import React from "react";

import styles from "./OutsideStageDisableOverlay.module.css";

export default ({ onClick }) => (
  <div
    className={styles["outside-stage-disable-overlay"]}
    onClickCapture={(e) => (e.preventDefault(), e.stopPropagation(), onClick && onClick())}
  ></div>
);
